<script setup>
defineProps({
  course: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <tbody class="courses-section-item">
    <tr class="course-item-instructor-row">
      <td class="course-instructor-first-column first-column"></td>
      <td class="course-instructor-name-column second-column">
        <div>
          <span class="course-item-instructor-name">{{ course.facultyLastNames }}</span>
        </div>
      </td>
      <td class="course-instructor-third-column third-column"></td>
    </tr>
    <tr class="course-item-main-row">
      <td class="course-item-time-wrapper first-column">
        {{ course.time }}
        <span v-if="course.time && course.timezoneLabel" class="course-item-time-timezone">
          <span>{{ course.timezoneLabel }}</span>
        </span>
      </td>

      <td class="course-item-title-wrapper second-column">
        <RouterLink
          :to="{ name: 'course-view', params: { courseSlug: course.slug } }"
          class="course-item-title-link"
        >
          {{ course.name }}
        </RouterLink>
      </td>

      <td class="course-item-type-wrapper third-column">
        {{ course.type }}
      </td>
    </tr>
  </tbody>
</template>

<style scoped></style>
